<template>
  <section>
    <p-school-news class="pc" v-if="viewShow=='pc'"></p-school-news>
    <m-school-news class="mobile" v-if="viewShow=='mobile'"></m-school-news>
  </section>
</template>
<script>
import MSchoolNews from './mobile/MSchoolNews'
import PSchoolNews from './pc/PSchoolNews'
export default {
  props: ['viewShow'],
  components: {
    PSchoolNews,
    MSchoolNews,
  }
}
</script>
<style lang="less" scoped>

</style>